import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Button } from '../styles/buttons';
import { spacing, colors } from '../styles/theme';
import CloseIcon from '../images/icons/close-icon';
import Text from '../styles/typography';

const ResetButton = styled(Button)`
  border-bottom: none;
  background-color: transparent;
`;

const RemoveButton = styled(Button)`
  margin: ${props => (props.isMobile ? `${spacing[0]} 0` : `0 ${spacing[0]}`)};
  border-bottom: none;
  background-color: transparent;
  display: flex;
  > svg {
    margin-right: ${spacing[0]};
  }
`;

const SelectedWrapper = styled.div`
  display: flex;
  width: 100vw;
  align-items: ${props => (props.isMobile ? 'flex-start' : 'center')};
  padding: ${props => (props.isMobile ? '20px 15px' : '30px 70px')};
  background-color: ${colors.darkGrey};
  flex-direction: ${props => (props.isMobile ? 'column' : 'row')};
`;

const FilterText = styled(Text.Span)`
  text-transform: capitalize;
`;
const SelectedTags = ({ checkedTags, handleReset, isMobile = false }) => (
  <If condition={Object.values(checkedTags).includes(true)}>
    <SelectedWrapper isMobile={isMobile}>
      <Text.Span>Selected filters:</Text.Span>
      <For each="filter" of={Object.entries(checkedTags)}>
        <If condition={filter[1] === true}>
          <RemoveButton
            key={filter[0]}
            isMobile={isMobile}
            onClick={() => handleReset(filter[0])}
            small
          >
            <CloseIcon />
            <FilterText>{filter[0].replace(/-/g, ' ')}</FilterText>
          </RemoveButton>
        </If>
      </For>
      <If condition={!isMobile}>
        <ResetButton onClick={() => handleReset('all')} small>
          Reset All
        </ResetButton>
      </If>
    </SelectedWrapper>
  </If>
);

SelectedTags.propTypes = {
  checkedTags: PropTypes.object,
  handleReset: PropTypes.func,
  isMobile: PropTypes.bool,
};

export default SelectedTags;
